var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 3.28C8.20569 3.28 8.40677 3.34099 8.57779 3.45527C8.74882 3.56955 8.88212 3.73197 8.96083 3.92201C9.03955 4.11204 9.06015 4.32115 9.02002 4.52289C8.97989 4.72463 8.88084 4.90994 8.73539 5.05539C8.58994 5.20084 8.40463 5.29989 8.20289 5.34002C8.00115 5.38015 7.79204 5.35955 7.60201 5.28084C7.41197 5.20212 7.24955 5.06882 7.13527 4.89779C7.021 4.72677 6.96 4.52569 6.96 4.32C6.96 4.04418 7.06957 3.77965 7.26461 3.58461C7.45965 3.38957 7.72417 3.28 8 3.28ZM10.56 11.82C10.56 12.0961 10.3361 12.32 10.06 12.32H6.26C5.98386 12.32 5.76 12.0961 5.76 11.82V11.54C5.76 11.2639 5.98386 11.04 6.26 11.04H7.52V7.52H6.74C6.46386 7.52 6.24 7.29614 6.24 7.02V6.74C6.24 6.46386 6.46386 6.24 6.74 6.24H8.3C8.57614 6.24 8.8 6.46386 8.8 6.74V11.04H10.06C10.3361 11.04 10.56 11.2639 10.56 11.54V11.82Z",
    fill: "#5F30E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.93a3aaed4d1f5378062521593667853c.svg";
export { ForwardRef as ReactComponent };